
import Button from '../../../components/base/Button';

export default function HeroSection() {
  return (
    <section 
      className="relative min-h-screen flex items-center justify-center bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)), url('https://public.readdy.ai/ai/img_res/6b998d82aaea392ba1acf0dca821c960.jpg')`
      }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
        <div className="text-center text-white">
          <h1 className="text-5xl md:text-7xl font-bold mb-8 leading-tight">
            <span className="block text-white/90 font-light text-3xl md:text-4xl mb-4">Create Our Future</span>
            <strong>沖縄起業</strong>を成功に導く<br />
            <strong>LP制作</strong>・ホームページ制作
          </h1>
          <p className="text-xl md:text-2xl mb-12 max-w-3xl mx-auto leading-relaxed font-light">
            沖縄拠点、起業、ビジネスに伴奏します<br />
            現地視点でのデザインとコンテンツ
          </p>
          <div className="flex justify-center">
            <Button size="lg" href="#contact">
              <i className="ri-phone-line mr-2"></i>
              無料相談を申し込む
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}
